<template>
    <div class="ProfessionalReview">
        <el-dialog title="详情" :visible.sync="ReviewBlon" width="60%" :show-close="true">
            <div class="CommDig">
                <div v-if="reviewInfo.company.remark" class="TitleBox" style="margin-top: 20px;">
                    <span>驳回备注</span>
                </div>
                <div v-if="reviewInfo.company.remark" class="ZhuanYeBoxInfo">
                    <el-input size="small" type="textarea" :rows="3" v-model="reviewInfo.company.remark" disabled></el-input>
                </div>
                <div class="TitleBox">
                    <span>基本信息</span>
                </div>
                <table width="100%" class="Table" v-if="reviewInfo.company">
                    <tbody>
                        <tr>
                            <td width="10%"><span class="Red">*</span>机构名称</td>
                            <td width="23%"><el-input size="small" v-model="reviewInfo.company.name"
                                    disabled></el-input></td>
                            <td width="10%"><span class="Red">*</span>机构法人</td>
                            <td width="23%"><el-input size="small" v-model="reviewInfo.company.legal_person"
                                    disabled></el-input>
                            </td>
                            <td width="10%">机构网址</td>
                            <td width="23%"><el-input size="small" v-model="reviewInfo.company.mechanism_website"
                                    disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>机构公众号</td>
                            <td><el-input size="small" v-model="reviewInfo.company.mechanism_wnumber"
                                    disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>营业执照</td>
                            <td>
                                <div class="TableDis">
                                    <div class="StepCommFileImg" v-if="reviewInfo.company.legal_license">
                                        <img :src="$Global.CommImgHttp + reviewInfo.company.legal_license" alt=""
                                            @click="OpenLock(reviewInfo.company.legal_license)">
                                    </div>
                                </div>
                            </td>
                            <td><span class="Red">*</span>联系人</td>
                            <td><el-input size="small" v-model="reviewInfo.company.link_name" disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>联系电话</td>
                            <td><el-input size="small" v-model="reviewInfo.company.link_mobile" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>联系邮箱</td>
                            <td><el-input size="small" v-model="reviewInfo.company.link_email" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>单位性质</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.company.institutions_text"
                                    disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>业务领域</td>
                            <td>
                                <el-input size="small" v-model="businessFieldDisplay" disabled></el-input>
                            </td>
                            <td colspan="4"></td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>通信地址</td>
                            <td colspan="5">
                                <div class="TableDis">
                                    <el-input size="small" v-model="reviewInfo.company.address" disabled></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>收件人</td>
                            <td><el-input size="small" v-model="reviewInfo.company.receiver_name" disabled></el-input></td>
                            <td>收件人联系方式</td>
                            <td><el-input size="small" v-model="reviewInfo.company.receiver_mobile" disabled></el-input></td>
                            <td>收件人地址</td>
                            <td><el-input size="small" v-model="reviewInfo.company.receiver_address" disabled></el-input></td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>简介</td>
                            <td colspan="5"><el-input size="small" type="textarea" :rows="2"
                                    v-model="reviewInfo.company.synopsis" disabled></el-input></td>
                        </tr>
                    </tbody>
                </table>
                <div class="TitleBox">
                    <span>专业信息</span>
                </div>
                <div class="ZhuanYeWai">
                    <!-- <div class="ZhuanYeTheme">{{ item.question_info.name }}</div> -->
                    <div class="ZhuanYeBox" v-for="(item, indexs) in ZhuanYeXinXiInfo">
                        <div class="ZhuanYeBoxInfo">
                            <div>
                                <span v-if="item.question_info.type == 2 || item.question_info.type == 4">{{
                                    indexs +
                                    1 }}. {{ item.question_info.name }}<span style="color: red;"> {{ item.answer
                                        }}
                                    </span>{{
                                        item.question_info.unit
                                    }}</span>
                                <span v-else>{{ indexs +
                                    1 }}. {{ item.question_info.name }}<span v-if="item.answer" style="color: red;"> {{ item.answer }}</span></span>
                            </div>
                        </div>
                        <div v-if="item.fileList">
                            <div class="UploadTitle">上传文件:</div>
                            <div class="ZhuanYeBoxFile" v-for="(t, indext) in item.fileList" :key="indext">
                                <div class="FileItem" @click="OpenLock(t)">
                                    <img :title="t.name" :src="$Global._isFileName(t.url)" alt="">
                                    <div :title="t.name" class="FileTitle">{{ t.name }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.templatefileList">
                            <div class="UploadTitle">文件:</div>
                            <div class="ZhuanYeBoxFile" v-for="(d, indexd) in item.templatefileList" :key="indexd">
                                <div class="FileItem" @click="OpenLock(d)">
                                    <img :title="d.name" :src="$Global._isFileName(d.url)" alt="">
                                    <div :title="d.name" class="FileTitle">{{ d.name }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="ZhuanYeBox ZhuanYeBox1" v-for="(items, indexs) in item.children">
                            <div class="ZhuanYeBoxInfo">
                                <div>
                                    <span v-if="items.question_info.type == 2 || items.question_info.type == 4">{{
                                        items.question_info.name }}<span style="color: red;"> {{ items.answer
                                            }}
                                        </span>{{
                                            items.question_info.unit
                                        }}</span>
                                    <span v-else> {{ items.question_info.name }}<span v-if="items.answer" style="color: red;"> {{ items.answer }}</span></span>
                                </div>
                            </div>
                            <div v-if="items.fileList">
                                <div class="UploadTitle">上传文件:</div>
                                <div class="ZhuanYeBoxFile" v-for="(t, indext) in items.fileList" :key="indext">
                                    <div class="FileItem" @click="OpenLock(t)">
                                        <img :title="t.name" :src="$Global._isFileName(t.url)" alt="">
                                        <div :title="t.name" class="FileTitle">{{ t.name }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="items.templatefileList">
                                <div class="UploadTitle">文件:</div>
                                <div class="ZhuanYeBoxFile" v-for="(d, indexd) in items.templatefileList" :key="indexd">
                                    <div class="FileItem" @click="OpenLock(d)">
                                        <img :title="d.name" :src="$Global._isFileName(d.url)" alt="">
                                        <div :title="d.name" class="FileTitle">{{ d.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            ReviewBlon: false,
            reviewInfo: {},
            ZhuanYeXinXiInfo: [],
        }
    },
    props: {
        companyDetails: {
            type: Object, //类型
            required: true, //必要性
            default: {} //默认值
        }
    },
    computed: {  // 新增 computed 计算属性
        businessFieldDisplay() {
            if (!this.reviewInfo.company || !this.reviewInfo.company.business_field) return '';
            const fieldMap = {
                '1': '心理咨询',
                '2': '心理治疗',
                '3': '心理评估',
                '4': '心理健康教育'
            };
            return fieldMap[this.reviewInfo.company.business_field] || this.reviewInfo.company.business_field;
        }
    },
    watch: {
        companyDetails: {
            handler(newVal, oldVal) {
                this.companyDetailsInit(newVal);
            },
            // immediate: true,
        }
    },
    methods: {
        companyDetailsInit(value) {
            this.reviewInfo = value;
            this.reviewInfo.company = value;
            
            // 处理专业信息
            let questionData = null;
            
            // 检查是否有update_question字段（type=1的情况）
            if (value.update_question && value.update_question.length > 0) {
                questionData = value.update_question;
            } else if (value.question && value.question.length > 0) {
                questionData = value.question;
            }
            
            if (questionData) {
                // 检查是否已经有question_info字段（companySearchDetails接口直接返回的）
                if (questionData[0].question_info) {
                    // 直接处理，不需要额外API
                    this.reviewInfo.question = questionData;
                    this.ZhuanYeXinXiInit();
                } else {
                    // 需要调用API获取题目信息
                    this.GetFormData();
                }
            }
        },
        
        GetFormData() {
            // 调用getRegisterInformation接口获取题目信息
            const params = {
                page: 2,
                user_group_id: this.reviewInfo.user_group_id,
            };
            
            // 如果是更新注册，添加type参数
            if (this.reviewInfo.type === 1) {
                params.type = 1;
            } else {
                params.type = 0;
            }
            
            this.$get("api/join_in/getRegisterInformation", params).then(res => {
                if (res.data.code == 1) {
                    // 获取问题列表
                    let question_list = res.data.data[0].question_list;
                    
                    // 确定要处理的数据源
                    let questionData = null;
                    if (this.reviewInfo.update_question && this.reviewInfo.update_question.length > 0) {
                        questionData = this.reviewInfo.update_question;
                    } else if (this.reviewInfo.question && this.reviewInfo.question.length > 0) {
                        questionData = this.reviewInfo.question;
                    }
                    
                    if (!questionData) {
                        console.error('没有找到问题数据');
                        return;
                    }
                    
                    // 创建一个扁平化的题目映射，包含所有父级和子级题目
                    const allQuestionsMap = {};
                    
                    // 先添加父级题目
                    question_list.forEach(parent => {
                        allQuestionsMap[parent.id] = {
                            name: parent.name,
                            type: parent.type,
                            unit: parent.unit
                        };
                        
                        // 再添加子级题目
                        if (parent.children && parent.children.length > 0) {
                            parent.children.forEach(child => {
                                allQuestionsMap[child.id] = {
                                    name: child.name,
                                    type: child.type,
                                    unit: child.unit
                                };
                            });
                        }
                    });
                    
                    console.log('所有题目映射:', allQuestionsMap);
                    
                    // 为每个问题添加question_info字段
                    questionData.forEach(question => {
                        const questionInfo = allQuestionsMap[question.user_question_bank_id];
                        question.question_info = {
                            name: questionInfo ? questionInfo.name : `问题 ${question.user_question_bank_id}`,
                            type: question.question_type,
                            unit: questionInfo ? questionInfo.unit : ''
                        };
                    });
                    
                    // 将处理后的数据赋值给reviewInfo.question
                    this.reviewInfo.question = questionData;
                    
                    // 处理专业信息
                    this.ZhuanYeXinXiInit();
                } else {
                    this.$message.error(res.data.msg)
                }
            }).catch(err => {
                console.error('获取问题信息失败:', err);
                this.$message.error('获取问题信息失败，请重试');
            });
        },
        
        ZhuanYeXinXiInit() {
            var { question } = this.reviewInfo;
            
            if (!question || question.length === 0) {
                console.log('没有专业信息数据');
                return;
            }
            
            // 构建父子关系结构
            const questionMap = {};
            const rootQuestions = [];
            
            // 先处理所有问题，建立映射关系
            question.forEach(item => {
                if (item.file && item.file !== '[]') {
                    item.fileList = JSON.parse(item.file);
                    item.fileList.forEach((t, indext) => {
                        item.fileList[indext].type = item.fileList[indext].name.split('\.').pop();
                    })
                }
                if (item.templatefile && item.templatefile !== '[]') {
                    item.templatefileList = JSON.parse(item.templatefile);
                    item.templatefileList.forEach((t, indext) => {
                        item.templatefileList[indext].type = item.templatefileList[indext].name.split('\.').pop();
                    })
                }
                
                questionMap[item.id] = item;
                item.children = [];
            });
            
            // 构建父子关系
            question.forEach(item => {
                if (item.pid === 0) {
                    // 根级问题
                    rootQuestions.push(item);
                } else {
                    // 子级问题
                    const parent = questionMap[item.pid];
                    if (parent) {
                        parent.children.push(item);
                    } else {
                        // 如果找不到父级，也作为根级问题显示
                        rootQuestions.push(item);
                    }
                }
            });
            
            console.log('原始问题数据:', question);
            console.log('处理后的根级问题:', rootQuestions);
            this.ZhuanYeXinXiInfo = rootQuestions;
        },
        OpenLock(res) {
            this.$Global.previewFile(res)
        },
        OpenReviewBlon() {
            this.ReviewBlon = true
        },
    }
}
</script>
<style scoped>
.PageDis {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.CommDig {
    max-height: 600px;
    overflow: auto;
}

.Table {
    width: 99%;
    margin: 10px auto;
    border-radius: 5px;
    border-collapse: collapse;
}

.Table td {
    border: 1px solid #e4eaec;
    padding: 10px;
    font-weight: 400;
    font-size: 16px;
    color: #666;
}

.Table .State {
    padding-right: 10px;
}

.Table .Th {
    color: #000000;
    font-size: 16px;
    padding: 10px;
    font-weight: 700;
}

.Table td .Red {
    color: #d51938;
    font-weight: 700;
    vertical-align: middle;
    /* margin-right: 10px; */
}

.Table .TableDis {
    display: flex;
    align-items: center;
}

.WidMax {
    width: 100%;
}

.TitleBox {
    width: 100%;
    height: 40px;
    background-color: #0385EB;
    line-height: 42px;
    margin-top: 10px;
    padding-left: 15px;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
    box-sizing: border-box;
}

.ZhuanYeWai {
    margin-top: 15px;
}

.ZhuanYeWai .ZhuanYeTheme {
    font-size: 16px;
    font-weight: 600;
    margin: 10px 0;
}

.ZhuanYeBox {
    font-size: 16px;
    background-color: #F5F5F5;
    padding: 20px;
    margin-bottom: 10px;
}

.ZhuanYeBox1 {
    padding: 10px;
}

.ZhuanYeBox .UploadTitle {
    font-size: 16px;
}

/* .ZhuanYeBox .ZhuanYeBoxInfo {
    margin-top: 20px;
} */

.ZhuanYeBoxFile {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 10px 10px 0 10px;
    border: 1px #0385EB solid;
    box-sizing: border-box;
}

.ZhuanYeBoxFile .FileItem {
    cursor: pointer;
    width: 90px;
    font-size: 14px;
    padding: 0 10px 10px 0;
}

.ZhuanYeBoxFile .FileItem .FileTitle {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 15px;
    width: 90px;
    margin-top: 2px;
}

.ZhuanYeBoxFile .FileItem img {
    width: 90px;
    height: 90px;
}

.AnLIBaoGaoBox {
    margin-top: 20px;
}

.ZhuanYeItem {
    width: 500px;
}

.ZhuanYeItemRadio {
    margin-top: 10px;
}

.ZhuanYeItemRadio .radio-label {
    font-weight: 600;
    font-size: 16px;
}

.ZhuanYeItemTit {
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    padding: 10px 0;
}

.ZhuanYeItemDis {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.ZhuanYeItemCont {
    width: 75%;
    margin: 10px 0 0 10px;
}

.ZhuanYeItemFuTit {
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    width: 30%;
}

.ZhuanYeItemVal {
    margin-left: 20px;
    flex: 1;
}

.SupervisorBox {
    padding-left: 20px;
}

.SpanColorRed {
    color: red;
}

.StepCommFileImg {
    border: 1px solid #ddd;
    padding: 2px;
    cursor: pointer;
    margin-left: 5px;
}

.StepCommFileImg img {
    width: 50px;
    height: 50px;
}
</style>
<style>
.ProfessionalReview .el-dialog__body {
    padding: 0 20px 20px 20px;
}
</style>